module.exports = __webpack_public_path__ + "files/72630b9c92958cb89d64ff53eea32ed6.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Droid-Serif-regular.woff
 ** module id = 850
 ** module chunks = 0
 **/